import { render } from "./ClientsIndexPage.vue?vue&type=template&id=d3ffead8"
import script from "./ClientsIndexPage.vue?vue&type=script&lang=js"
export * from "./ClientsIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__